import { formatDate } from '../date/format-date';

import { isBlockInactive, isBlockNotYetActive } from './is-block-inactive';

const getTooltipContent = (
  isBlock: boolean,
  isArchived: boolean,
  isInactive: boolean,
  expiryDate: string,
  inceptionDate: string,
) => {
  const entityName = isBlock ? 'block' : 'clause';

  if (isArchived) {
    return `This ${entityName} has been archived`;
  }

  if (isBlockNotYetActive(inceptionDate)) {
    return `Effective from: ${formatDate(inceptionDate, 'DD MMMM YYYY')}`;
  }

  if (isInactive) {
    return `This ${entityName} is inactive`;
  }

  if (expiryDate) {
    return `Effective to: ${formatDate(expiryDate, 'DD MMMM YYYY')}`;
  }

  return '';
};

export const getBlockExpiryDateTooltip = (
  inceptionDate: string = '',
  expiryDate: string = '',
  isBlock: boolean,
  isArchived: boolean = false,
) => {
  const isInactive = isBlockInactive(inceptionDate, expiryDate);

  return {
    isInactive,
    tooltip: getTooltipContent(isBlock, isArchived, isInactive, expiryDate, inceptionDate),
  };
};
